module.exports = __webpack_public_path__ + "static/img/11areaA_08.4a8c1e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/11areaA_08.png
// module id = 1001
// module chunks = 1